import { useDeviceLayout } from "../../view/hooks"

export const isMobile = useDeviceLayout({
	isMobile: true
})

export const successOptions = ({
	modal
}) => {
	const style = {
		position: isMobile ? 'top-center' : modal ? 'top-center' : 'bottom-left',
		style: {
			borderRadius: '1.2rem',
			padding: '1rem',
			background: '#21ba45',
			minHeight: '3rem',
			maxHeight: '3rem',
			boxSizing: 'border-box',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			textAlign: 'center',
			fontSize: '1rem',
			color: '#fff',
			marginTop: isMobile ? '.4rem' : modal ? '2rem' : '5.625rem',
			zIndex: 1302,
		},
		closeStyle: {
			color: 'white',
			fontSize: '14px',
		},
	}
	return style
}

export const errorOptions = ({
	modal
}) => {
	const style = {
		position: isMobile ? 'top-center' : modal ? 'top-center' : 'bottom-left',
		style: {
			borderRadius: '1.2rem',
			padding: '1rem',
			background: '#c10015',
			minHeight: '3rem',
			maxHeight: '3rem',
			boxSizing: 'border-box',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			textAlign: 'center',
			fontSize: '1rem',
			color: '#fff',
			marginTop: isMobile ? '.4rem' :  modal ? '2rem' : '5.625rem',
			zIndex: 1302,
		},
		closeStyle: {
			color: 'white',
			fontSize: '14px',
		},
	}
	return style
}
